import { divide } from "helpers/math";

// this is used to sanitize a percent field input
// in the event that the value needs to be used for maths
export function parsePercentageToFloat(percent) {
  if (typeof percent !== "string") return null;
  const sanitizedPercent = percent.replaceAll(",", "");
  return divide(parseFloat(sanitizedPercent), 100);
}
